export default {
  setValue(state, { property, data }) {
    state[property] = data;
  },
  setFilterValue(state, { property, data }) {
    state.filters[property] = data;
  },
  setFilters(state, data) {
    state.filters.academicYear = data.academicYear;
    state.filters.month = null;
    state.filters.service = null;
    state.filters.sieorappointment = null;

    state.filters.center = data.center;
    state.filters.district = data.district;
    state.filters.municipality = data.municipality;
    state.filters.school = data.school;

    state.filters.status = null;
    state.filters.numberAppointment = null;
  },
  setCollections(state, data) {
    this.setAcademicYears(state, data.academicYears);
    this.setCenters(state, data.centers);
    this.setDistricts(state, data.districts);
    this.setMunicipalities(state, data.municipalities);
    this.setSchools(state, data.schools);
  },
  setResults(state, results) {
    state.results = results;
  },
  setResultsIdx(state, { result, idx }) {
    state.results[idx] = result;
  },
  setPagination(state, conf) {
    state.pagination = conf;
  },
  setCurrentPage(state, pageNumber) {
    state.pagination.currentPage = pageNumber;
  },
  setAcademicYears(state, data) {
    state.collections.academicYears = data;

    let selectedAcademicYear = data.find((x) => x.selected);

    if (selectedAcademicYear != undefined) {
      state.filters.academicYear = selectedAcademicYear;
    }
  },
  setMonths(state, data) {
    state.collections.months = data || [];
  },
  setServices(state, data) {
    state.collections.services = data || [];
  },
  setCenters(state, data) {
    state.collections.centers = data || [];

    if (data != null && data.length == 1 && data[0].selected) {
      state.filters.center = data[0];
      state.centerDisabled = true;
    } else {
      state.centerDisabled = false;
    }
  },
  setDisciplines(state, data) {
    state.collections.disciplines = data || [];
  },
  setDistricts(state, data) {
    state.collections.districts = data || [];

    if (data != null && data.length == 1 && data[0].selected) {
      state.filters.district = data[0];
      state.districtDisabled = true;
    } else {
      state.districtDisabled = false;
    }
  },
  setMunicipalities(state, data) {
    state.collections.municipalities = data || [];

    if (data != null && data.length == 1 && data[0].selected) {
      state.filters.municipality = data[0];
      state.municipalityDisabled = true;
    } else {
      state.municipalityDisabled = false;
    }
  },
  setSchools(state, data) {
    state.collections.schools = data || [];

    if (data != null && data.length == 1 && data[0].selected) {
      state.filters.school = data[0];
      state.schoolDisabled = true;
    } else {
      state.schoolDisabled = false;
    }
  },
  setStatus(state, data) {
    state.collections.status = data || [];
  },
  setProviders(state, data) {
    state.collections.providers = data || [];
  },
  setSpecialits(state, data) {
    state.collections.specialists = data || [];
  },
  resetByAcademicYear(state) {
    state.filters.month = null;
    state.filters.district = null;
    state.filters.municipality = null;
    state.filters.school = null;
    state.filters.specialist = null;
    state.filters.center = null;
    state.filters.provider = null;

    state.collections.months = [];
    state.collections.districts = [];
    state.collections.municipalities = [];
    state.collections.schools = [];
    state.collections.specialists = [];
    state.collections.centers = [];
    state.collections.providers = [];
  },
  resetByCenter(state) {
    state.filters.district = null;
    state.filters.municipality = null;
    state.filters.school = null;

    state.collections.districts = [];
    state.collections.municipalities = [];
    state.collections.schools = [];
  },
  resetByDistrict(state) {
    state.filters.municipality = null;
    state.filters.school = null;

    state.collections.municipalities = [];
    state.collections.schools = [];
  },
  resetByProvider(state) {
    state.filters.specialist = null;

    state.collections.specialists = [];
  },
  resetByMunicipality(state) {
    state.filters.school = null;

    state.collections.schools = [];
  },
  resetResults(state) {
    state.results = [];
  },
};
